import { render } from "./defeatedOrder.vue?vue&type=template&id=e30ec142&ts=true"
import script from "./defeatedOrder.vue?vue&type=script&lang=ts"
export * from "./defeatedOrder.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__